<template>
  <footer :class="{ absolute }">
    <div class="footer-content">
      <div class="footer-logo">
        <AppLogo />
      </div>
      <div class="footer-links">
        <h4>© {{ new Date().getFullYear() }}, GHEG</h4>
        <a :href="route('home.privacy-policy')">Privacy policy</a>
        <a :href="route('home.terms-of-use')">Terms of use</a>
        <a href="https://support.virtualce.app" target="_blank">Platform Documentation</a>
      </div>
    </div>
  </footer>
</template>

<script>
import AppLogo from '@/Components/Icons/AppLogoWhite.vue';

export default {
  components: {
    AppLogo,
  },
  props: {
    absolute: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
footer {
  background-color: #1a3b47;
  width: 100%;
  padding: 24px;

  .footer-content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 48px;

    .footer-links {
      display: flex;
      gap: 24px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;
      line-height: 21px; /* 150% */

      a {
        text-decoration: underline;
        text-underline-offset: 3px;
      }
    }
  }
}
</style>
